
import "./App.css";
import {
    getFirestore,
    collection,
    query,
    where,
    doc,
    getDoc,
    getDocs,
    updateDoc,
    onSnapshot,
    Timestamp,
    deleteField
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import { decodeSerialNumber } from "./helpers";

const firebaseConfig = {
    apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
    authDomain: "loftie-4f472.firebaseapp.com",
    databaseURL: "https://loftie-4f472.firebaseio.com",
    projectId: "loftie-4f472",
    storageBucket: "loftie-4f472.appspot.com",
    messagingSenderId: "302939981606",
    appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
    measurementId: "G-L8VGQXX28P",
};

const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);

function Refurb() {
    const [user, userLoading, userError] = useAuthState(auth);
    const [refurbDocData, setRefurbDocData] = useState({})
    const [isAuthorized, setIsAuthorized] = useState(false)
    const [refurbDevices, setRefurbDevices] = useState([])



    useEffect(() => {
        const loftieConnectRef = doc(collection(getFirestore(firebaseApp), "loftie-connect-users"), "gahaEaNQvF3hmWrmsCNd")
        onSnapshot(loftieConnectRef, async (doc) => {
            if (doc.exists()) {
                const docData = doc.data()
                setRefurbDocData(docData)
                const devices = docData['pending_devices']
                for (let i = 0; i < devices.length; i++) {
                    const device = devices[i]
                    if (!device.refurbCompleted) {

                        const deviceRef = device.deviceRef
                        const deviceDoc = await getDoc(deviceRef)
                        device.deviceData = deviceDoc.data()

                    }
                }
                setRefurbDevices(devices)
            }
        })
    }, [])

    const addLampModes=(device)=>{
        const state = device.deviceData?.state
        delete state['lampModes']
        const refurbLampModes = refurbDocData?.lampModes
        state['lampModes'] = refurbLampModes
        const loftieConfigRef = doc(collection(getFirestore(firebaseApp), "device-configs"), device.id)
        updateDoc(loftieConfigRef, { 'value': state })

    }

    const refurbCategories = refurbDocData['refurb_categories']
    const subCategories = refurbDocData['sub_categories']
    let numberRefurbedLofties = refurbDocData['number_refurbed_lofties']
    const [userEmail, setUserEmail] = useState(null)

    const checkDeviceType=(device)=>{
        const ver = device.deviceData?.state.Ver
        if (ver.charAt(0)==='L'){
            return 'lamp'
        }else {
            return 'clock'
        }

        
    }

    console.log(refurbDocData.lampModes)
    const refurbLoftie = async (device) =>{
        const loftieDeviceRef = doc(collection(getFirestore(firebaseApp), "devices"), device.id)
        const docSnap = await getDoc(loftieDeviceRef)
        if (docSnap.exists()){
            const deviceData = docSnap.data()
            console.log("device data", deviceData)
            const deviceVer = deviceData?.state['Ver']
            console.log(deviceVer)
            if (deviceVer && deviceVer[0] === 'L'){
                refurbLoftieLamp(device)
            }else{
                refurbLoftieClock(device)
            }
        }

    }

    const refurbLoftieLamp = async(device) => {
        console.log("lamp", device)
        const loftieConfigRef = doc(collection(getFirestore(firebaseApp), "device-configs"), device.id)
        const docSnap = await getDoc(loftieConfigRef)
        if (docSnap.exists()) {
            const loftieConfigData = docSnap.data()

            const restoreCommand = {
                'restoreToDefault':1
            }

            updateDoc(loftieConfigRef, { 'value': restoreCommand})
        }
        //DELETE DEVICE PERSONAL INFORMATION
        const loftieDeviceDetails = doc(collection(getFirestore(firebaseApp), "device-details"), device.id)
        updateDoc(loftieDeviceDetails, {'name': deleteField()})  
        
        const loftieDeviceDoc = doc(collection(getFirestore(firebaseApp),"devices"), device.id)
        updateDoc(loftieDeviceDoc, 
            {
                'customModes': deleteField(),
                'lampMode1Ref': deleteField(),
                'lampMode2Ref': deleteField()
            }
        )


        const loftieConnectRef = doc(collection(getFirestore(firebaseApp), "loftie-connect-users"), "gahaEaNQvF3hmWrmsCNd")
        numberRefurbedLofties +=1 
        console.log(numberRefurbedLofties)
        // create new array of refubdevices with the deviceData property removed
        removeDeviceFromRefurb(device)
        removeUsersFromDevice(device.id)
        updateDoc(loftieConnectRef, {'number_refurbed_lofties':numberRefurbedLofties})

    }

    const refurbLoftieClock = async (device) => {
        if (refurbData.deviceId == device.id && refurbData.refurbInformationSubmited == true) {
            const defaultConfig = refurbDocData['refurb_config']
            const loftieConfigRef = doc(collection(getFirestore(firebaseApp), "device-configs"), device.id)
            console.log(defaultConfig)
            try {
                const docSnap = await getDoc(loftieConfigRef)
                if (docSnap.exists()) {
                    const loftieConfigData = docSnap.data()

                    updateDoc(loftieConfigRef, { 'value': defaultConfig })
                    removeUsersFromDevice(device.id)
                }
                const loftieConnectRef = doc(collection(getFirestore(firebaseApp), "loftie-connect-users"), "gahaEaNQvF3hmWrmsCNd")
                numberRefurbedLofties +=1 
                console.log(numberRefurbedLofties)
                // create new array of refubdevices with the deviceData property removed
                removeDeviceFromRefurb(device)
                updateDoc(loftieConnectRef, {'number_refurbed_lofties':numberRefurbedLofties})
            } catch (error) {
                console.error("error", error.message, error.code)
            }

            const deviceDetailsRef = doc(collection(getFirestore(firebaseApp), "device-details"), device.id)
            try {
                const deviceDetailsDoc = await getDoc(deviceDetailsRef)
                if (deviceDetailsDoc.exists()) {

                    updateDoc(deviceDetailsRef, { 'name': "", 'wifiName': "" })
                }
            } catch (error) {
                console.log(error)
            }

        } else {
            alert("Submit refurb information first")
        }
    }
    const removeUsersFromDevice = async (deviceId) => {
        const usersRef = collection(getFirestore(firebaseApp), "users")
        const q = query(usersRef, where("devices", "array-contains", { id: deviceId }))
        const querySnapshot = await getDocs(q)
        querySnapshot.forEach((d) => {
            const docData = d.data()
            const userDevices = docData['devices']
            const updatedDevices = userDevices.filter((dev) => dev.id !== deviceId)
            console.log(deviceId, docData['email'], d.id)
            const deviceData = { 'id': deviceId, 'date': new Date() }
            const pastDevice = docData['pastDevices'] || [];
            const updatedPastDevices = [...pastDevice, deviceData]
            console.log(updatedDevices)
            const docId = d.id
            const userRef = doc(collection(getFirestore(firebaseApp), "users"), docId)
            updateDoc(userRef, { 'devices': updatedDevices, 'pastDevices': updatedPastDevices })
        })
    }


    const [refurbData, setRefurbData] = useState({
        orderNumber: '',
        deviceId: '',
        firmware: false,
        hardware: false,
        returnCategory: '',
        returnSubCategory: '',
        foundIssueCategory: '',
        additionalNotes: '',
        refurbInformationSubmited: false,
        working: false,
        issueSubCategory: ''
    });

    const addRefurbReason = async (device) => {
        delete refurbData.deviceId
        delete refurbData.refurbInformationSubmited
        const deviceRef = device.deviceRef
        const deviceDoc = await getDoc(deviceRef)
        const deviceData = deviceDoc.data()
        const refurbReason = deviceData['refurb_reason'] || []
        const reasonData = {
            'reason': refurbData,
            'date': device.addedAt
        }
        const refurbReasons = [...refurbReason, reasonData]
        updateDoc(deviceRef, { 'refurb_reason': refurbReasons })
        setRefurbData({ ...refurbData, deviceId: device.id, refurbInformationSubmited: true })
    }
    const [lightOn, setLightOn] = useState(false)

    const light = async (device) => {
        const ver = device.deviceData?.state.Ver
        setLightOn(!lightOn)
        const loftieConfigRef = doc(collection(getFirestore(firebaseApp), "device-configs"), device.id)
        try {
            const docSnap = await getDoc(loftieConfigRef)
            if (docSnap.exists()) {
                const loftieConfigData = docSnap.data()
                const type = checkDeviceType(device)
                if (type === 'lamp'){
                    const state = device.deviceData?.state
                    delete state['lampOn']
                    state['lampOn'] = lightOn
                    console.log(type)
                    updateDoc(loftieConfigRef, { 'value': state })
                }
                else {
                    updateDoc(loftieConfigRef, { 'value': {'nightLightOn':lightOn}})

                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const removeDeviceFromRefurb = async (device)=>{
        const deletedDeviceArray = refurbDevices.filter(map => map['id'] !== device.id)
        try {
            const updatedDevices = deletedDeviceArray.map(device=>{
                delete device.deviceData
                return device
            })
            const loftieConnectRef = doc(collection(getFirestore(firebaseApp), "loftie-connect-users"), "gahaEaNQvF3hmWrmsCNd")
            updateDoc(loftieConnectRef, {'pending_devices': updatedDevices})
            setRefurbDevices(deletedDeviceArray)
            
        }catch(error){
            console.error("error removing device", error)
        }
    }


    return (
        <Container>
            <Table striped bordered hover>
                <thead>
                    <td>Device ID / Serial</td>
                    <td>Return Information</td>
                </thead>
                <tbody>
                    {refurbDevices?.map((device) => {
                        if (!device?.refurbCompleted) {
                            return (
                                <tr key={device.id} >
                                    <td ><strong>{device.id}</strong><br></br>
                                    {decodeSerialNumber(device?.deviceData?.state?.['serialNumber'])}
                                    <br></br>
                                    </td>
                                    {/* <td>{decodeSerialNumber(device?.state?.['serialNumber'])}</td> */}
                                    <td>
                                        <Form>
                                            <Row>
                                            <Col>
                                                    <Form.Control type="text" placeholder="order number"
                                                        value={refurbData[device.id]?.orderNumber}
                                                        onChange={(e) =>
                                                            setRefurbData({ ...refurbData, deviceId: device.id, orderNumber: e.target.value })}>

                                                    </Form.Control>
                                                </Col>
                                                <Col>
                                                <Col>
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Loftie Working"
                                                        variant="outline-primary"
                                                        onChange={() => setRefurbData({ ...refurbData, working: !refurbData.working, deviceId: device.id })}
                                                    />
                                                </Col>
                                                </Col>
                                                <Col>
                                                    <Form.Check
                                                        value={refurbData[device.id]?.firmware}
                                                        onChange={() => setRefurbData({ ...refurbData, firmware: !refurbData.firmware, deviceId: device.id })
                                                        }
                                                        type='checkbox' id={`default-checkbox`} label={'Firmware'}
                                                    />
                                                    <Form.Check
                                                        value={refurbData[device.id]?.hardware}
                                                        onChange={(e) => setRefurbData(
                                                            { ...refurbData, deviceId: device.id, hardware: !refurbData.hardware })
                                                        }
                                                        type={'checkbox'} label={'Hardware'} id={'default-checkbox'}
                                                    />
                                                </Col>
                                                <Col>
                                                <Col>
                                                Return Reasons
                                                    <Form.Select
                                                        value={refurbData[device.id]?.returnCategory}
                                                        onChange={(e) => setRefurbData({ ...refurbData, deviceId: device.id, returnCategory: e.target.value })}
                                                    >
                                                        <option>Choose Reason</option>
                                                        {refurbCategories?.map((category) => {
                                                            return (
                                                                <option value={category}>{category}</option>
                                                            )
                                                        })}
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                    <Form.Select
                                                        value={refurbData[device.id]?.returnSubCategory}
                                                        onChange={(e) => setRefurbData({ ...refurbData, deviceId: device.id, returnSubCategory: e.target.value })}
                                                    >
                                                        <option>Choose Sub Reason</option>
                                                        {subCategories?.map((reason) => {
                                                            return (
                                                                <option value={reason}>{reason}</option>

                                                            )
                                                        })}
                                                    </Form.Select>
                                                </Col>
                                                </Col>
                                                <Col>
                                                Found Issue
                                                <Col>
                                                <Form.Select
                                                        value={refurbData[device.id]?.foundIssueCategory}
                                                        onChange={(e) => setRefurbData({ ...refurbData, deviceId: device.id, foundIssueCategory: e.target.value })}
                                                    >
                                                        <option>Choose Reason</option>
                                                        {refurbCategories?.map((category) => {
                                                            return (
                                                                <option value={category}>{category}</option>
                                                            )
                                                        })}
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                    <Form.Select
                                                        value={refurbData[device.id]?.issueSubCategory}
                                                        onChange={(e) => setRefurbData({ ...refurbData, deviceId: device.id, issueSubCategory: e.target.value })}
                                                    >
                                                        <option>Choose Sub Reason</option>
                                                        {subCategories?.map((reason) => {
                                                            return (
                                                                <option value={reason}>{reason}</option>

                                                            )
                                                        })}
                                                    </Form.Select>
                                                </Col>
                                                </Col>
                                                <Col>
                                                    <Form.Control type="text" placeholder="additonal notes"
                                                        value={refurbData[device.id]?.additionalNotes}
                                                        onChange={(e) =>
                                                            setRefurbData({ ...refurbData, deviceId: device.id, additionalNotes: e.target.value })}>

                                                    </Form.Control>
                                                </Col>
                                                <Col>
                                                    <Button type="submit" variant="outline-primary" onClick={(e) => { e.preventDefault(); addRefurbReason(device) }}>
                                                        Submit Reasons
                                                    </Button>
                                                    </Col>
                                            </Row>
                                        </Form>
                                    </td>
                                    <td><Button type="button" onClick={() => { refurbLoftie(device) }}>Refurb Loftie</Button></td>
                                    <td><Button variant='outline-primary' onClick={() => light(device)}>Light</Button></td>
                                    <td><Button variant='outline-primary' onClick={() => addLampModes(device)}>Set Lamp Modes</Button></td>
                                    <td><Button variant = 'outline-primary' onClick = {()=>removeDeviceFromRefurb(device)}>Remove Device</Button></td>
                                </tr>
                            )
                        }
                    })}
                </tbody>
            </Table>

        </Container>
    )

}


export default Refurb



